/* eslint-disable */
import { compose, lifecycle, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get, split } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import WithShopCurrency from '../hoc/WithShopCurrency';
import { getSelectedServicesPrepaid } from '../services/selectors';
import { ANY_BARBER } from '../constants';
import {
  addAdultsOnlyField,
  addCustomerToWaitingList,
  applePay,
  applePayAddCustomerToWaitingList,
  createReservation,
  processPayment,
  resetFee,
  resetFields,
  resetPaymentProcessing,
  resetPromo,
  resetTip,
  removeReservedTime,
} from './actions';
import WithTimeWaitingList from '../hoc/WithTimeWaitingList';
import { errorRedirect } from '../actions';
import { fetchBarbers } from '../barbers/actions';
import { fetchSelectedServices } from '../services/actions';
import { fetchShop } from '../shops/actions';
import {
  nullFunc,
  formatReservationTime,
} from '../utils/helpers';
import {
  getAdultsOnly,
  getHasShopLoyaltyProgram,
  getHasPromotionsEnabled,
  getHasWaitingListEnabled,
  getShopAllowBookAndReserve,
  getShopId,
  getShopTimezone,
  getNoExtrasForReserveNoPay,
  getShopName,
} from '../shops/selectors';
import {
  getBarberBookNoPay, getBarberId, getHasBarberLoyaltyProgram
} from '../barbers/selectors';
import { getThirdPartyPromotion } from '../selectors';
import { getUser, getIsFormValid, getIsFormPristine, getBookAndPayCopy, getPaymentProcessing } from './selectors';
import { tipShape } from '../shapes';
import MakeReservation from './components/MakeReservation';
import WithShopName from '../hoc/WithShopName';
import withCost from './containers/withCost';
import withKioskProp from '../hoc/WithKioskProp';
import OnUnload from '../hoc/OnUnload';
import analytics from '../applicationServices/analytics/BookingAnalytics';
import config from '../../config';
import AskForEmailConsent from './components/AskForEmailConsentModal';
import AskForEmailConsentModalContents from './components/AskForEmailConsentContents';
import AskForSMSConsentModalContents from './components/AskForSMSConsentContents';
import withKioskIsReserveOnly from './containers/withKioskIsReserveOnly';

class MakeReservationContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      analyticsFired: false,
      showPromo: false,
      smsConsent: null,
      emailConsent: null,
    };
  }

  componentWillMount() {
    this.props.resetTip();
    this.props.resetFee();
    this.props.resetPromo();
    this.props.resetFields();
    this.props.resetPaymentProcessing();
    this.props.fetchShop()
      .then(this.props.fetchService)
      .then(this.props.fetchBarbers)
      .catch(nullFunc);
  }

  componentDidMount() {
    this.getInitialStateOfConsentPrompts();
  }

  getTip() {
    if (!this.props.tipEnabled) return null;
    const activeTip = get(this.props, 'activeTip.value');
    return activeTip ? activeTip.value : null;
  }

  getTipAmount() {
    if (!this.props.tipEnabled) return null;
    return get(this.props, 'tipAmount');
  }

  getPaymentEnabled() {
    if (!this.props.isFormValid) return false;
    if (this.props.processing) return false;

    const paymentEnabled = !(!this.props.timeWaitingList && !this.props.timeAvailable);

    if (paymentEnabled && !this.state.analyticsFired) {
      analytics.fillPersonalInfo();
      this.setState({ analyticsFired: true });
    }

    return paymentEnabled;
  }

  getPaymentProps() {
    return {
      barberId: this.props.barberId,
      user: this.props.user,
      tip: this.getTip(),
      tipAmount: this.getTipAmount(),
      bookNoPay: this.props.bookNoPay,
      hasLoyaltyProgram: this.props.hasLoyaltyProgram,
      hasPromotions: this.props.hasPromotions,
      anyBarber: this.props.anyBarber,
      promoCode: this.props.promoCode,
    };
  }

  createReservation(props) {
    let thirdPartyPromotions = [this.props.thirdPartyPromo.context];
    const paymentProps = { ...this.getPaymentProps(), ...props };

    if (paymentProps.bookNoPay === true || (paymentProps.isReservation === true && paymentProps.bookNoPay === false)) {
      thirdPartyPromotions = [];
    }

    // check for null status in array
    if (thirdPartyPromotions.length > 0 && thirdPartyPromotions[0] === null) {
      thirdPartyPromotions = [];
    }

    this.props.processPayment();
    this.props.createReservation({
      thirdPartyPromotions,
      ...paymentProps,
    });
  }

  handleReserveAndPay = async (token) => {
  // We're adding timeout here... because browsers are stupid.
  // When paying with Apple Pay, the system UI will pop up and
  // it will ask for confirmation and so on. Once the request is
  // complete, we'd immediately go into getting user consent;
  // this causes the apple pay modal to get all confused and
  // report a payment error, even though the payment did go through
  // (likely this is due to UI thread going into a deadlock)

  // If we add a timeout, it plays the 'success' animation
  // and we're all good to go.

    setTimeout(async () => {
      const consents = await this.askForConsent();

      this.createReservation({
        consents,
        bookNoPay: false,
        token,
      });

    }, 20);
  };

  handleBookAndReserve = async (token) => {
    const consents = await this.askForConsent();

    this.createReservation({
      consents,
      bookNoPay: false,
      isReservation: true,
      token,
      tipAmount: 0,
    });
  };

  getConsentsFromRemote = async (firstName = '', lastName = '', phone = '', email = '') => {
    const shopId = this.props.shopId;

    const settings = await fetch(`${config.url}/shop/${shopId}/notifications-consent`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        firstName, lastName, phone, email
      })
    }).then(res => res.json());

    const askForSmsConsent = settings.showPrompt.promotional.phone;
    const askForEmailConsent = settings.showPrompt.promotional.email;

    return { askForSmsConsent, askForEmailConsent };
  }

  getInitialStateOfConsentPrompts = async () => {
    const { askForSmsConsent, askForEmailConsent } = await this.getConsentsFromRemote();

    if (!askForSmsConsent) {
      this.setState({ smsConsent: true });
    }

    if (!askForEmailConsent) {
      this.setState({ emailConsent: true });
    }
  }

  askForConsent = async () => {
    const paymentProps = this.getPaymentProps();

    const { firstName, lastName, phone, email } = paymentProps.user;
    const { shopName } = this.props;

    let { smsConsent, emailConsent } = this.state;

    // Don't ask for anything if we've already gotten both consents - eg. if shop isn't asking for them at all
    if (emailConsent !== null && smsConsent !== null) {
      return { smsConsent, emailConsent }
    }


    const { askForSmsConsent, askForEmailConsent } = await this.getConsentsFromRemote(firstName, lastName, phone, email)

    if (askForSmsConsent) {
      smsConsent = await AskForEmailConsent('askForSmsConsent', AskForSMSConsentModalContents, { shopName });
      this.setState({ smsConsent });
    } else if (smsConsent === null) {
      smsConsent = true; // If theres no need to ask for consent AND it wasn't already rejected, we assume its given
      this.setState({ smsConsent: true });
    }

    if (askForEmailConsent) {
      emailConsent = await AskForEmailConsent('askForEmailConsent', AskForEmailConsentModalContents, { shopName });
      this.setState({ emailConsent });
    } else if (emailConsent === null) {
      emailConsent = true; // If theres no need to ask for consent AND it wasn't already rejected, we assume its given
      this.setState({ emailConsent: true });
    }

    return { smsConsent, emailConsent }
  }

  handleReserve = async (turnstileToken) => {
    const consents = await this.askForConsent();
    this.createReservation({ tipAmount: 0, consents, turnstileToken });
  };

  applePay = async (isReservation) => {
    const consents = await this.askForConsent();

    this.props.processPayment();

    this.props.applePay({
      barberId: this.props.barberId,
      tip: this.getTip(),
      tipAmount: this.getTipAmount(),
      bookNoPay: false,
      hasLoyaltyProgram: this.props.hasLoyaltyProgram,
      anyBarber: this.props.anyBarber,
      amount: this.props.totalAmount,
      promoCode: this.props.promoCode,
      isReservation,
      consents,
    });
  };

  addCustomerToWaitingList = async (token) => {
    // We're adding timeout here... because browsers are stupid.
    // When paying with Apple Pay, the system UI will pop up and
    // it will ask for confirmation and so on. Once the request is
    // complete, we'd immediately go into getting user consent;
    // this causes the apple pay modal to get all confused and
    // report a payment error, even though the payment did go through
    // (likely this is due to UI thread going into a deadlock)

    // If we add a timeout, it plays the 'success' animation
    // and we're all good to go.

    setTimeout(async () => {
      const consents = await this.askForConsent();

      this.props.processPayment();
      const { user } = this.props;
      const tipAmount = this.getTipAmount();
      const payload = {
        user,
        token: token.id,
        tip: this.getTip(),
        consents,
      };

      if (tipAmount !== null) {
        payload.tipAmount = tipAmount;
      }

      this.props.addCustomerToWaitingList(payload);
    }, 20);
  };

  applePayAddCustomerToWaitingList = async () => {
    const consents = await this.askForConsent();

    this.props.processPayment();

    const { user } = this.props;
    this.props.applePayAddCustomerToWaitingList(user, this.getTipAmount(), { consents });
  };

  render() {
    const {
      servicesNamesShort,
      servicesNamesLong,
      totalAmount,
      bookNoPay,
      hasLoyaltyProgram,
      hasPromotions,
      tipEnabled,
      activeTip,
      user,
      taxes,
      reservationTime,
      noAutofill,
      timeWaitingList,
      bookAndReserve,
      bookAndPayCopy,
      noExtrasForBookNoPay,
    } = this.props;

    return (
      <MakeReservation
        handleReserveAndPay={this.handleReserveAndPay}
        handleBookAndReserve={this.handleBookAndReserve}
        handleReserve={this.handleReserve}
        applePay={this.applePay}
        addCustomerToWaitingList={this.addCustomerToWaitingList}
        applePayAddCustomerToWaitingList={this.applePayAddCustomerToWaitingList}
        showPromo={this.state.showPromo}

        {...{
          servicesNamesShort,
          servicesNamesLong,
          totalAmount,
          bookNoPay,
          hasLoyaltyProgram,
          hasPromotions,
          tipEnabled,
          activeTip,
          userEmail: user.email,
          paymentEnabled: this.getPaymentEnabled(),
          taxes,
          reservationTime,
          noAutofill,
          timeWaitingList,
          bookAndReserve,
          bookAndPayCopy,
          noExtrasForBookNoPay,
        }}
      />);
  }
}

MakeReservationContainer.propTypes = {
  totalAmount: PropTypes.number,
  bookNoPay: PropTypes.bool,
  hasLoyaltyProgram: PropTypes.bool,
  hasPromotions: PropTypes.bool,
  fetchShop: PropTypes.func.isRequired,
  fetchBarbers: PropTypes.func.isRequired,
  fetchService: PropTypes.func.isRequired,
  tipEnabled: PropTypes.bool,
  activeTip: tipShape,
  createReservation: PropTypes.func.isRequired,
  applePay: PropTypes.func.isRequired,
  isFormValid: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
  resetFields: PropTypes.func.isRequired,
  resetPromo: PropTypes.func.isRequired,
  processPayment: PropTypes.func.isRequired,
  resetPaymentProcessing: PropTypes.func.isRequired,
  barberId: PropTypes.string,
  processing: PropTypes.bool,
  timeAvailable: PropTypes.bool.isRequired,
  taxes: PropTypes.number,
  anyBarber: PropTypes.bool,
  servicesNamesShort: PropTypes.string,
  servicesNamesLong: PropTypes.string,
  reservationTime: PropTypes.string,
  promoCode: PropTypes.string,
  resetFee: PropTypes.func.isRequired,
  resetTip: PropTypes.func.isRequired,
  noAutofill: PropTypes.bool,
  timeWaitingList: PropTypes.bool.isRequired,
  addCustomerToWaitingList: PropTypes.func.isRequired,
  applePayAddCustomerToWaitingList: PropTypes.func.isRequired,
  bookAndReserve: PropTypes.bool,
  bookAndPayCopy: PropTypes.string,
  noExtrasForBookNoPay: PropTypes.bool.isRequired,
};

MakeReservationContainer.defaultProps = {
  barberId: '',
  totalAmount: 0,
  bookNoPay: false,
  hasLoyaltyProgram: false,
  hasPromotions: true,
  tipEnabled: false,
  activeTip: null,
  processing: false,
  anyBarber: false,
  servicesNamesShort: '',
  servicesNamesLong: '',
  reservationTime: '',
  promoCode: '',
  taxes: 0,
  noAutofill: false,
  bookAndReserve: false,
  bookAndPayCopy: '',
};

const addAdultsOnlyFieldIfEnabled = (props) => {
  if (props.adultsOnly) props.addAdultsOnlyField(props.shopName);
};

const formProps = compose(
  WithShopName,
  withCost,
  withKioskIsReserveOnly,
  connect(
    (state, ownProps) => ({
      errorMessage: state.app.errorMessage,
      fields: state.reservation.get('fields').toJS(),
      isFormValid: getIsFormValid(state),
      isFormPristine: getIsFormPristine(state),
      user: getUser(state),
      adultsOnly: getAdultsOnly(state, ownProps.params.shopRoute),
      bookAndPayCopy: getBookAndPayCopy(
        state,
        ownProps.params.shopRoute,
        ownProps.params.barberRoute,
        ownProps.params.serviceId,
        ownProps.totalAmount,
        ownProps.isCoveredByDiscount,
        ownProps.isReserveNoPayOnly,
      ),
    }),
    {
      resetFields,
      errorRedirect,
      addAdultsOnlyField,
    }
  ),
  lifecycle({
    componentDidMount() {
      addAdultsOnlyFieldIfEnabled(this.props);
      this.props.resetPromo()
      this.props.resetTip();
    },
    componentDidUpdate(nextProps) {
      if (this.props.adultsOnly !== nextProps.adultsOnly) addAdultsOnlyFieldIfEnabled(this.props);
    },
  }),
);

const reservationTimeProps = connect(
  (state, ownProps) => {
    const timezone = getShopTimezone(state, ownProps.params.shopRoute);
    return {
      timeAvailable: state.reservation.get('timeAvailable'),
      reservationTime: formatReservationTime(ownProps.params.reservationTime, timezone),
      barberId: getBarberId(state, ownProps.params.barberRoute),
      shopId: getShopId(state, ownProps.params.shopRoute),
      hasWaitingList: getHasWaitingListEnabled(state, ownProps.params.shopRoute),
      timezone,
    };
  },
);

const paymentProps = connect(
  (state, ownProps) => {
    const isServicePrepayRequired = !getSelectedServicesPrepaid(state, ownProps.params.serviceId);
    return {
      barberId: getBarberId(state, ownProps.params.barberRoute),
      shopId: getShopId(state, ownProps.params.shopRoute),
      shopName: getShopName(state, ownProps.params.shopRoute),
      bookNoPay: getBarberBookNoPay(state, ownProps.params.barberRoute) && !isServicePrepayRequired,
      hasLoyaltyProgram: (
        getHasBarberLoyaltyProgram(state, ownProps.params.barberRoute)
        || getHasShopLoyaltyProgram(state, ownProps.params.shopRoute)
      ),
      hasPromotions: (getHasPromotionsEnabled(state, ownProps.params.shopRoute)),
      processing: getPaymentProcessing(state),
      anyBarber: !!get(ownProps, 'location.query.anyBarber'),
      promoCode: state.reservation.getIn(['promo', 'promoCode']),
      bookAndReserve: getShopAllowBookAndReserve(state, ownProps.params.shopRoute) && !isServicePrepayRequired,
      noExtrasForBookNoPay: getNoExtrasForReserveNoPay(state, ownProps.params.shopRoute),
      thirdPartyPromo: getThirdPartyPromotion(state),
    };
  },
  (dispatch, ownProps) => bindActionCreators({
    fetchShop: fetchShop.bind(null, ownProps.params.shopRoute, ownProps.urlPattern),
    fetchBarbers: fetchBarbers.bind(null, ownProps.params.shopRoute, ownProps.params, ownProps.urlPattern),
    fetchService: fetchSelectedServices.bind(null,
      ownProps.params.shopRoute,
      ownProps.params.barberRoute,
      ownProps.params.serviceId,
      ownProps.params,
      ownProps.urlPattern,
    ),
    createReservation: params => createReservation({
      redirectUrl: `${ownProps.baseUrl || ''}/view-reservation`,
      serviceIds: ownProps.params.serviceId,
      reservationTime: ownProps.params.reservationTime,
      kiosk: ownProps.kiosk,
      ...params,
    }),
    applePay: params => applePay({
      redirectUrl: `${ownProps.baseUrl || ''}/view-reservation`,
      serviceIds: ownProps.params.serviceId,
      reservationTime: ownProps.params.reservationTime,
      currency: ownProps.currency,
      ...params,
    }),
    addCustomerToWaitingList,
    applePayAddCustomerToWaitingList,
    processPayment,
    resetPaymentProcessing,
    resetPromo,
    resetFee,
    resetTip,
  }, dispatch),
  (stateProps, dispatchProps, ownProps) => {
    const props = { ...ownProps, ...stateProps, ...dispatchProps };
    props.addCustomerToWaitingList = params => dispatchProps.addCustomerToWaitingList({
      shopId: props.shopId,
      barberId: props.barberId === ANY_BARBER ? undefined : props.barberId,
      serviceIds: split(ownProps.params.serviceId, ';'),
      day: get(props, 'location.query.date', ''),
      redirectUrl: '/waiting-list',
      ...params,
    });

    props.applePayAddCustomerToWaitingList = (user, tipAmount, params) =>
      dispatchProps.applePayAddCustomerToWaitingList(props.costWithTaxes, props.currency, {
        ...params,
        shopId: props.shopId,
        barberId: props.barberId === ANY_BARBER ? undefined : props.barberId,
        serviceIds: split(ownProps.params.serviceId, ';'),
        day: get(props, 'location.query.date', ''),
        redirectUrl: '/waiting-list',
        user,
        tipAmount,
      });
    return props;
  }
);

export default compose(
  withCost,
  withKioskProp,
  WithTimeWaitingList,
  WithShopCurrency,
  withRouter,
  paymentProps,
  formProps,
  reservationTimeProps,
  withHandlers({
    onUnload: props => () => removeReservedTime(props.barberId),
  }),
  OnUnload,
)(MakeReservationContainer);



// WEBPACK FOOTER //
// ./src/app/reservation/MakeReservation.jsx